export default __webpack_public_path__ + "e2ea9fd2c64038330dbf072c52bb4782.png";